'use client';

import { useMemo } from 'react';
import classNames from 'classnames';
import { defaultProcessText } from 'app/utility/textProcessing';

import { IPrice } from 'app/interfaces/prices';
import usePriceStore from './store';
import styles from './PriceTable.module.scss';

export default function PriceTableNew({
  items,
  initialId
}: {
  items: IPrice[];
  initialId: string | number | null;
}) {
  const { currentItemId } = usePriceStore();
  const currentItem = useMemo<IPrice | null>(() => {
    // До монтирования стор пуст — используем initialId (совпадает с SSR-рендером).
    const activeId = currentItemId ?? initialId;
    return items.find(item => item.id === activeId) || null;
  }, [items, currentItemId, initialId]);

  return (
    !!currentItem?.content && (
      <div
        className={classNames(
          'bg-white rounded overflow-auto no-scrollbar',
          styles.table
        )}
        dangerouslySetInnerHTML={{
          __html: defaultProcessText(currentItem.content)
        }}
      ></div>
    )
  );
}
